import BookingFormRoute from './booking-form.jsx'

export default BookingFormRoute;